<mat-toolbar>
  <a mat-icon-button [routerLink]="['/search']" aria-label="Back to search menu">
    <mat-icon>arrow_back_ios_new</mat-icon>
  </a>
  <span>{{"SEARCH_FAVOURITE_PLAYERS" | translate}}</span>
</mat-toolbar>

<div class="app-page">
  <div class="filters-row">
    <label for="favorites-period">Period</label>
    <select
      id="favorites-period"
      [value]="selectedNoOfDaysBack"
      (change)="onPeriodChanged($any($event.target).value)">
      @for (option of periodOptions; track option.value) {
        <option [value]="option.value">{{ option.label }}</option>
      }
    </select>
  </div>

  @if (isLoading) {
    <div class="loader-wrap">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  }

  @if (!isLoading && players.length === 0) {
    <div class="empty-state">
      <mat-icon>info</mat-icon>
      <span>{{"SEARCH_NO_FAVOURITE_PLAYERS_FOUND" | translate}}</span>
    </div>
  }

  @if (!isLoading && players.length > 0) {
    <div class="player-cards">
      @for (player of players; track getPlayerId(player)) {
        <details class="player-card">
          <summary>
            <div class="player-title">
              <span class="player-name">{{ getLastName(player) }}, {{ getFirstName(player) }}</span>
              <span class="player-meta">{{ getPositionId(player) | position }} | {{ getDivisionName(player) }}</span>
              <span class="events-indicator">{{ getTotalEventsCount(player) }} events</span>
            </div>
          </summary>

          <div class="player-card-content">
<!--             <div class="section-header">Played games</div>
            @if (getLatestGames(player).length === 0) {
              <div class="empty-row">No games in selected period</div>
            }
            @for (game of getLatestGames(player); track game.GameId) {
              <div class="info-row">
                <a [routerLink]="['/games', game.GameId]">{{ getGameLabel(game) || 'Open game' }}</a>
                <span>{{ game.GameDate | date:'yyyy-MM-dd' }}</span>
              </div>
            }

            <div class="section-header">Reports</div>
            @if (getLatestReports(player).length === 0) {
              <div class="empty-row">No reports in selected period</div>
            }
            @for (report of getLatestReports(player); track report.ReportId) {
              <div class="info-row">
                <a [routerLink]="['/scouting/report', report.ReportId]">{{ getReportLabel(report) }}</a>
                <span>{{ report.DateCreated | date:'yyyy-MM-dd' }}</span>
              </div>
            }

            <div class="section-header">Notes</div>
            @if (getLatestNotes(player).length === 0) {
              <div class="empty-row">No notes in selected period</div>
            }
            @for (note of getLatestNotes(player); track note.PlayerNoteId) {
              <div class="info-row">
                <a [routerLink]="['/player/details', getPlayerId(player)]">{{ note.Text || 'Open note on player' }}</a>
                <span>{{ note.DateCreated | date:'yyyy-MM-dd' }}</span>
              </div>
            }

            <div class="section-header">Statistics</div>
            @if (getLatestStatistics(player).length === 0) {
              <div class="empty-row">No statistics in selected period</div>
            }
            @for (stat of getLatestStatistics(player); track $index) {
              <div class="info-row">
                <span>{{ getStatisticLabel(stat) }}</span>
                <span>{{ stat.GameDate | date:'yyyy-MM-dd' }}</span>
              </div>
            } -->

            <div class="player-actions">
              <a mat-button [routerLink]="['/player/details', getPlayerId(player)]">Open player</a>
            </div>
          </div>
        </details>
      }
    </div>
  }
</div>
